<mat-dialog-content>
  <h2 class="dialog-title" mat-dialog-title>{{ 'ADDITIONAL_SERVICE_PLANNING.SCHEDULE_TEMPLATES' |
  transloco }}</h2>

  <form [formGroup]="timeSlotsForm">

    <div class="feature-item mt-3 mb-3">
      <h4 class="mb-3 flex-fill">{{ 'ADDITIONAL_SERVICE_PLANNING.NAME' | transloco }}</h4>
      <div class="d-flex gap-2">

        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
          <input matInput formControlName="name" [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco">
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
          <input matInput formControlName="nameSv" [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco">
        </mat-form-field>

      </div>
    </div>

    <div class="feature-item mt-3 mb-3">
      <h4 class="mb-3 flex-fill">{{ 'ADDITIONAL_SERVICE_PLANNING.DESCRIPTION' | transloco }}</h4>
      <div class="d-flex gap-2">
        <mat-form-field class="flex-fill" appearance="outline">
          <mat-label>{{ 'PARKING_EDIT.ENGLISH' | transloco }}</mat-label>
          <textarea matInput formControlName="description"
          [placeholder]="'PARKING_EDIT.ENGLISH_TEXT' | transloco"></textarea>
        </mat-form-field>

        <mat-form-field class="flex-fill" appearance="outline">
          <mat-label>{{ 'PARKING_EDIT.SWEDISH' | transloco }}</mat-label>
          <textarea matInput formControlName="descriptionSv"
          [placeholder]="'PARKING_EDIT.SWEDISH_TEXT' | transloco"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div formArrayName="timeSlots">
      @for (slot of timeSlots.controls; track slot; let i = $index) {
        <div [formGroupName]="i"
          class="d-flex gap-2 mb-2 align-items-start">
          <mat-form-field class="flex-fill" appearance="outline">
            <mat-label>{{ 'ADDITIONAL_SERVICE_PLANNING.TIME' | transloco }}</mat-label>
            <input matInput type="time" formControlName="time" />
          </mat-form-field>
          <mat-form-field class="flex-fill" appearance="outline">
            <mat-label>{{ 'ADDITIONAL_SERVICE_PLANNING.CAPACITY' | transloco }}</mat-label>
            <input matInput type="number" min="1" formControlName="capacity" />
          </mat-form-field>
          <button mat-icon-button color="warn" type="button" (click)="removeTimeSlot(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }
    </div>

    <div class="d-flex justify-content-end align-items-center mt-3">
      <span class="add-time-slots-label">{{ 'ADDITIONAL_SERVICE_PLANNING.ADD_TIME_SLOTS' | transloco }}</span>
      <button mat-mini-fab color="primary" type="button" (click)="addTimeSlot()" [disabled]="!timeSlots.valid">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close>{{ 'ADDITIONAL_SERVICE_PLANNING.CANCEL' | transloco }}</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!timeSlotsForm.valid">{{
    'ADDITIONAL_SERVICE_PLANNING.SAVE' | transloco
  }}</button>
</mat-dialog-actions>